import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const SpacerCell = memo(() => <ViewTableCell />);
SpacerCell.displayName = "SpacerCell";
